import { Asset } from "expo-asset";
import * as Font from "expo-font";

/**
 * Web版のアイコンフォントを、実際に使う 32 個だけへ絞った 9KB のフォントへ差し替える。
 *
 * @expo/vector-icons は Icon が最初に描画されたときに Ionicons.ttf(389KB / 転送210KB)を
 * font-display: auto で読み込む。2026-09-06 の実測では、これが
 *   - クリティカルパスを 210KB ぶん占有して主役画像の取得開始を遅らせる(LCP 6.3秒の一因)
 *   - フォント差し替えでカテゴリ選択の行がずれる(CLS 0.013)
 *   - Lighthouse の font-display を score 0.5 にする
 * の3つを同時に起こしていた。
 *
 * ここで先に同じフォント名 "ionicons" を font-display: swap で登録しておくと、
 * expo-font の loadPromises / キャッシュが効いて Icon 側の読み込みは行われない
 * (expo-font/build/Font.js の loadFontInNamespaceAsync がフォント名で重複を排除する)。
 * 結果、大きい方の TTF はネットワークに出ない。
 *
 * サブセットの作り直しは `python 自動化/アイコンフォント最適化.py`。
 * 使うアイコンを増やして流し忘れると `npm run test` の verify-ui-e2e が落ちる。
 *
 * ネイティブは iconFont.native.js（何もしない）。端末内にフォントを同梱するため
 * ダウンロードが発生せず、差し替える利点が無い。
 */
// react-native-web 0.21 は Image.resolveAssetSource を持たないため expo-asset から解決する
const SUBSET = Asset.fromModule(require("./assets/fonts/Ionicons-subset.ttf"));

export const ICON_FONT_URI = SUBSET.uri;

Font.loadAsync({ ionicons: { uri: SUBSET.uri, display: Font.FontDisplay.SWAP } }).catch(() => {
  // 失敗しても @expo/vector-icons が従来どおり本体のフォントを読むため、表示は壊れない。
});
